import type { HandlingUnit } from "~/shared/types/quote-details-types";

export const mapItemToHandlingUnit = (item: HandlingUnit) => {
	const width =
		typeof item.dimensionWidth === "number" ? item.dimensionWidth : 0;
	const height =
		typeof item.dimensionHeight === "number" ? item.dimensionHeight : 0;
	const length =
		typeof item.dimensionLength === "number" ? item.dimensionLength : 0;

	return {
		id: item.id,
		description: item.description ?? "",
		quantity: item.quantity ?? 1,
		unit: item.unit ?? { id: 0, name: "", code: "" },
		weight: item.weight ?? 0,
		dimensionHeight: height,
		dimensionLength: length,
		dimensionWidth: width,
		nmfc: item.nmfc ?? "",
		class: item.class ?? "",
		density: item.density ?? 0,
		isHazmat: item.isHazmat ?? false,
		isStackable: item.isStackable ?? false,
		name: "",
		pieceCount: item.pieceCount ?? null,
		dimensions: "",
		width: 0,
		height: 0,
		length: 0,
		estClass: 0,
		isNested: false,
		measuringType: "weight",
		properShippingName: item.properShippingName ?? "",
		unNumber: item.unNumber ?? null,
		hazmatClass: item.hazmatClass,
		packingGroupId: item.packingGroupId,
		emergencyContactName: item.emergencyContactName ?? "",
		emergencyContactPhone: item.emergencyContactPhone ?? "",
	};
};
